<template>
  <div class="mall">
    <div class="inner">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        v-if="clientWidth > 900"
      >
        <el-tab-pane :label="$t('儲值點數')" name="1"></el-tab-pane>
        <el-tab-pane :label="$t('購買元寶')" name="2"></el-tab-pane>
        <el-tab-pane :label="$t('購買記錄')" name="3"></el-tab-pane>
      </el-tabs>
      <div class="mobile-nav" v-else>
        <div
          :class="activeName === item.value ? 'nav-active' : 'm-nav-item'"
          @click="mNavhandleClick(item.value)"
          v-for="(item, index) in navData"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>

      <Recharge v-show="activeName === '1'" />

      <YuanBao v-show="activeName === '2'" />

      <Record ref="record" v-show="activeName === '3'" />
    </div>
  </div>
</template>
<script>
import Recharge from "./components/recharge";
import YuanBao from "./components/yuanBao";
import Record from "./components/record";
import { mapState } from "vuex";
export default {
  components: {
    Recharge,
    YuanBao,
    Record,
  },
  computed: {
    ...mapState({
      currentTpye: (state) => state.header.currentTpye,
      clientWidth: (state) => state.screen.clientWidth,
    }),
  },
  watch: {
    currentTpye(newVal) {
      this.activeName = newVal;
      if (newVal === 3 && this.$route.query.id) {
        this.$refs.record.showDetail(this.$route.query.getData);
        this.$refs.record.showDetail(this.$route.query.id);
      }
    },
  },
  data() {
    return {
      activeName: "1",
      navData: [
        {
          name: this.$t("儲值點數"),
          value: "1",
        },
        {
          name: this.$t("購買元寶"),
          value: "2",
        },
        {
          name: this.$t("購買記錄"),
          value: "3",
        },
      ],
    };
  },
  mounted() {
    this.activeName = this.$store.state.header.currentTpye || "1";
  },
  methods: {
    handleClick() {},
    mNavhandleClick(val) {
      this.activeName = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.mall {
  min-height: 80vh;
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  .inner {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    @media only screen and (max-width: 900px) {
      width: 90%;
    }
    .mobile-nav {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media only screen and (max-width: 900px) {
        margin-bottom: 20px;
        font-size: 14px;
      }
      .m-nav-item {
        @media only screen and (max-width: 900px) {
          flex: 1;
          text-align: center;
          height: 40px;
          line-height: 40px;
        }
      }
      .nav-active {
        @media only screen and (max-width: 900px) {
          flex: 1;
          text-align: center;
          height: 40px;
          line-height: 40px;
          color: #c6a86c;
          border-bottom: 2px solid #c6a86c;
        }
      }
    }
  }
}
::v-deep .el-input-group__prepend {
  border-radius: 0;
}
::v-deep .el-tabs__nav-scroll {
  width: 100%;
}
::v-deep .is-top::after {
  background-color: transparent;
}
::v-deep .is-active {
  color: #c6a86c;
}
::v-deep .el-tabs__active-bar {
  background-color: #c6a86c;
  height: 3px;
}
::v-deep .el-tabs__item {
  &:hover {
    color: #c6a86c;
  }
  font-size: 18px;
}
</style>
